import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SinSidebarLayout } from 'layouts/SinSidebarLayout';

export const ConsentimientoDatos = () => {
  const Section = ({ number, title, children, level = 1 }) => {
    // Mapeo de indentación por nivel
    const indentClass =
      {
        1: 'pl-0',
        2: 'pl-4',
        3: 'pl-8',
        4: 'pl-12'
      }[level] || 'pl-16'; // niveles mayores siguen aumentando

    return (
      <div className={`section level-${level} mb-4 ${indentClass}`}>
        <Heading type={`h${level + 3}`}>
          {number} {title}
        </Heading>
        {children}
      </div>
    );
  };

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
        <Heading type="h2" className="text-center">
          CONSENTIMIENTO EXPRESO E INFORMADO PARA EL TRATAMIENTO DE DATOS
          PERSONALES
        </Heading>
        <div className="bg-background-primary p-5 sm:p-10 rounded">
          <Section>
            <Text className="mb-4">
              Otorgo mi consentimiento expreso, libre, específico, informado e
              inequívoco para que <strong>NEWEND SPA</strong> trate mis datos
              personales, y/o los de los representantes y contactos de la
              Persona Jurídica que registro, con las siguientes finalidades
              esenciales para el uso de la <strong>Plataforma</strong>:
            </Text>

            <ul className="list-disc list-inside mb-4">
              <li>
                Gestionar mi registro y autenticar mi acceso a la Plataforma.
              </li>
              <li>
                Comunicar mis datos de contacto a otros Usuarios interesados en
                mis publicaciones.
              </li>
              <li>
                Permitir la creación de mi perfil en el Directorio público de la
                Plataforma.
              </li>
              <li>
                Realizar comunicaciones operativas y de servicio relacionadas
                con mi cuenta.
              </li>
              <li>
                Utilizar la información de mi actividad y de los
                recursos/residuos que manejo, de forma anonimizada y agregada,
                para realizar investigación y generar reportes que identifiquen
                oportunidades y soluciones para el ecosistema de la Economía
                Circular.
              </li>
              <li>
                Cumplir con las obligaciones de seguridad y reporte de
                incidentes.
              </li>
            </ul>

            <Text className="mb-4">Declaro estar informado de que:</Text>

            <ul className="list-disc list-inside mb-4">
              <li>
                El <strong>Responsable del tratamiento</strong> es{' '}
                <strong>NEWEND SPA</strong>.
              </li>
              <li>
                Mis datos serán tratados conforme a los Principios de Licitud y
                Lealtad, Finalidad, Proporcionalidad, Calidad, Responsabilidad,
                Confidencialidad, Transparencia y Seguridad.
              </li>
              <li>
                La negativa a otorgar este consentimiento impedirá mi registro y
                el uso de la Plataforma.
              </li>
              <li>
                Puedo revocar este consentimiento y ejercer mis derechos de
                acceso, rectificación, supresión, oposición y portabilidad en
                cualquier momento, contactando a{' '}
                <a
                  href="mailto:contacto@plataforma-industria-circular.cl"
                  className="text-blue-600 underline"
                >
                  contacto@plataforma-industria-circular.cl
                </a>
                .
              </li>
            </ul>
          </Section>
        </div>
      </div>
    </SinSidebarLayout>
  );
};
